import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import saveAs from 'file-saver';
import { Table } from 'primeng/table';
import {
  ProgramTypesGUID,
  PaymentBatchStatus,
  ProgramTypes
} from '../../../models/_enum-collections';
import { ApiResponse } from '../../../models/api-response.model';
import { DownloadPaymentScheduleCSV } from '../../../models/download-payment-schedule-csv.model';
import {
  PaymentBatchEngagement,
  PaymentBatchEngagementExport
} from '../../../models/payment-batch-engagement.model';
import { PaymentBatchStatusDropDown } from '../../../models/payment-batch-status.model';
import { PaymentBatch } from '../../../models/payment-batch.model';
import { PaymentScheduleEngagements } from '../../../models/payment-schedule-engagements.model';
import { AppConstants } from '../../common/app-constants';
import { CommonService } from '../../common/common.service';
import { SettingsService } from '../../common/settings.service';
import { CommonSharedModule } from '../../common/shared.module';
import { ExportService } from '../../services/export.service';
import { PaymentScheduleService } from '../../services/payment-schedule.service';
import { WorkshopCodeService } from '../../services/workshop-code.service';

@Component({
  selector: 'app-edit-payment-batch',
  templateUrl: './edit-payment-batch.component.html',
  styleUrls: ['./edit-payment-batch.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class EditPaymentBatchComponent implements OnInit {
  program: ProgramTypesGUID | null = null;
  csiProgram: ProgramTypesGUID = ProgramTypesGUID.MSSP;
  @ViewChild('dt', { static: false }) dt!: Table;
  pbName!: string;
  editPaymentBatchForm!: FormGroup;
  selectedpaymentBatchStatusID: any;
  isBatchInOpenStatus = false;
  engcols!: any[];
  apires!: ApiResponse;
  msgs: any[] = [];
  collecteIdArray: any[] = [];
  collecteId!: string;
  paymentBatchEngagement!: PaymentBatchEngagement[];
  engagementList: PaymentScheduleEngagements[] = [];
  paymentBatchStatus: PaymentBatchStatusDropDown[] = [];
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  emptyRecordMsg!: string;
  currentPageInfo!: string;
  totalRecords!: number;
  tblPageNumber!: number;
  marked = false;
  isFeatureFlagEnabled = false;
  updatePaymentBatch!: PaymentBatch;
  selectedEngagements!: PaymentScheduleEngagements[];
  clonedEngs: Record<number, PaymentScheduleEngagements> = {};
  editing = false;
  editingHeaderCheck = false;
  editingNav = false;
  check = false;
  showForm = true;
  disableSubmit = false;
  isSpin = false;
  isSpinEx = false;
  downloadCSV: DownloadPaymentScheduleCSV[] = [];
  copyAssociatedEngagements!: PaymentScheduleEngagements[];
  editedRowEngagementIds: number[] = [];
  addedRowEngagementIds: number[] = [];
  deletedRowEngagementIds: number[] = [];
  firstEditInitEng!: PaymentScheduleEngagements;
  editRowsCtr = 0;
  isShowOnlyAssoctd = true;
  isDataLoading = false;
  paymentBatchEngagementExport: PaymentBatchEngagementExport[] = [];
  loading = false;
  loadingIcon = 'fa-circle-o-notch';
  programtypes = [
    { programName: 'MCAP', programTypeID: 1 },
    { programName: 'MSSP', programTypeID: 2 },
    { programName: 'Operator', programTypeID: 3 },
    { programName: 'Advisor Incentive', programTypeID: 5 }
  ];
  confirmationModalDisplay = false;
  isAmountreduced = false;
  programTypeId: ProgramTypesGUID | null = null;
  selectedProgramOption!: string;

  constructor(
    private pmService: PaymentScheduleService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    public settings: SettingsService,
    private exportService: ExportService,
    public http: HttpClient,
    public workshopcodeService: WorkshopCodeService
  ) {}

  ngOnInit() {
    const _programTypeId = this.route.snapshot.queryParamMap.get('program');
    this.programTypeId = _programTypeId as ProgramTypesGUID;
    this.selectedProgramOption = this.getSelectedProgramOptionByProgramTypeGuid(
      this.programTypeId
    );
    this.loading = true;
    this.pbName = this.route.snapshot.paramMap.get('pbName') || '';
    this.editing = false;
    this.editingHeaderCheck = false;
    this.dataViewRecsPerPage = 15;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.engcols = [
      { field: 'engagementID', header: 'Engagement ID' },
      { field: 'engagementName', header: 'Engagement Name' },
      { field: 'engagementSubType', header: 'Sub Type' },
      { field: 'partnerName', header: 'Partner Name' },
      { field: 'payeeID', header: 'Payee ID' },
      { field: 'paymentProfileStatus', header: 'Profile Status' },
      { field: 'partnerPriority', header: 'Partner Priority' },
      { field: 'blockedStatus', header: 'Blocked Status' },
      { field: 'sspaStatus', header: 'SSPA Status' },
      { field: 'partnerLocation', header: 'Partner Location' },
      { field: 'fiscalYear', header: 'Fiscal Year' },
      { field: 'partnerID', header: 'Partner ID' },
      { field: 'vendorID', header: 'Vendor ID' },
      { field: 'payeeName', header: 'Payee Name' },
      { field: 'amount', header: 'Amount' },
      { field: 'msInvoiceNumber', header: 'MS Invoice Number' },
      { field: 'msInvoicePaidDate', header: 'MS Invoice Paid Date' },
      {
        field: 'paymentCentralTransactionID',
        header: 'Payment Central Transaction ID'
      }
    ];

    this.getPaymentBatchStatus();

    this.editPaymentBatchForm = this.formBuilder.group({
      paymentBatchName: [''],
      paymentBatchScheduleDate: ['', [Validators.required]],
      anticipatedPaymentDate: ['', [Validators.required]],
      actualPaymentCentralDate: [''],
      paymentBatchStatus: ['', [Validators.required]],
      selectedEngs: [''],
      amount: [''],
      partnerID: [''],
      payeeName: [''],
      contactName: [''],
      contactEmail: [''],
      emailLanguage: [''],
      accountCode: [''],
      internalOrderOrCostCenter: [''],
      currency: [''],
      netAmount: [''],
      actualizedAmount: [''],
      taxAmount: [''],
      msInvoiceNumber: [''],
      msInvoicePaidDate: [''],
      paymentCentralTransactionID: [''],
      paymentCentralRequestID: ['']
    });
    this.getPaymentBatchEng(this.pbName);
    this.getDownloadCSVFile(this.pbName);
    const programTypeId = this.route.snapshot.queryParamMap.get('program');
    this.program = programTypeId as ProgramTypesGUID;
  }

  getDownloadCSVFile(bname) {
    this.pmService.getDownloadCSVFileEdit(bname).subscribe(downloadReport => {
      this.downloadCSV = downloadReport;
    });
  }

  downloadExportCSV() {
    this.isSpinEx = true;
    const headers = new HttpHeaders();
    const downloadUrl =
      this.settings.baseUrl + 'api/PoeInformation/DownloadPOEDocs';
    this.http
      .post(downloadUrl, this.selectedEngagements, {
        headers,
        responseType: 'blob'
      })
      .subscribe(downloadFile => {
        this.isSpinEx = false;
        this.downloadExportPoeCSV();
        this.saveFile(
          downloadFile,
          this.editPaymentBatchForm.controls['paymentBatchName'].value + '.zip'
        );
      });
  }

  downloadExportPoeCSV() {
    this.isSpinEx = true;
    this.pmService
      .downloadExportPoeCSV(this.selectedEngagements)
      .subscribe(downloadFile => {
        this.isSpinEx = false;
        this.saveFile(
          downloadFile,
          this.editPaymentBatchForm.controls['paymentBatchName'].value +
            '-Survey' +
            '.zip'
        );
      });
  }

  saveFile(data: Blob, fileName: string) {
    const file = new Blob([data], { type: 'application/octet-stream' });
    saveAs(file, fileName);
  }

  showConfirmationModal() {
    this.confirmationModalDisplay = true;
  }

  closeConfirmationModal() {
    this.confirmationModalDisplay = false;
  }

  onExportAndChangeStatus() {
    this.pmService.ProcessPaymentCap().subscribe(() => {
      this.editPaymentBatchForm.controls['paymentBatchStatus'].setValue({
        oDimEngagementPaymentBatchStatusId: PaymentBatchStatus.InProgress,
        paymentBatchStatus: PaymentBatchStatus[PaymentBatchStatus.InProgress]
      });
      this.onSubmit(true);
    });
  }

  exportCSV() {
    this.paymentBatchEngagementExport = [];

    this.engagementList.forEach(data => {
      this.paymentBatchEngagementExport.push({
        TransactionId:
          data.engagementID +
          '_' +
          this.workshopcodeService.getWorshopCode(data.engagementSubType || ''),
        PayeeName: data.payeeName,
        VendorID: data.vendorID,
        payeeID: data.payeeID,
        ContactName: data.contactName,
        ContactEmail: data.contactEmail,
        EmailLanguage: data.emailLanguage,
        AccountCode: data.accountCode,
        InternalOrderOrCostCenter: data.internalOrderOrCostCenter,
        Currency: data.currency,
        ActualizedAmount: data.actualizedAmount,
        TaxAmount: data.taxAmount
      });
    });

    this.exportService.exportToCsv(
      this.paymentBatchEngagementExport,
      this.pbName + '.csv'
    );
  }

  setMessage(msg: any, severity: string, noReset?: boolean) {
    if (!noReset) {
      this.msgs = [];
    }
    this.msgs.push({ severity: severity || 'error', detail: msg });
  }

  isEngagementInAssociated(engagementID: number) {
    return this.copyAssociatedEngagements.some(
      e => e.engagementID === engagementID
    );
  }

  async getPaymentBatchEng(pbName: string): Promise<void> {
    this.pmService
      .getPaymentBatchEngagement(
        pbName,
        this.settings.AliasName || '',
        this.programTypeId as any
      )
      .subscribe(paymentBatchDetails => {
        this.loading = false;

        this.pbName = pbName;
        this.isBatchInOpenStatus =
          paymentBatchDetails.paymentScheduleBatch
            .oDimEngagementPaymentBatchStatusId == PaymentBatchStatus.Open;

        this.editPaymentBatchForm.controls['paymentBatchStatus'].patchValue({
          oDimEngagementPaymentBatchStatusId:
            paymentBatchDetails.paymentScheduleBatch
              .oDimEngagementPaymentBatchStatusId,
          paymentBatchStatus:
            paymentBatchDetails.paymentScheduleBatch.paymentBatchStatus
        });

        const datePipe = new DatePipe('en-US');
        const epaymentBatchScheduleDate = datePipe.transform(
          paymentBatchDetails.paymentScheduleBatch.paymentBatchScheduleDate,
          'MM/dd/yyyy'
        );
        const eanticipatedPaymentDate = datePipe.transform(
          paymentBatchDetails.paymentScheduleBatch.anticipatedPaymentDate,
          'MM/dd/yyyy'
        );
        const eactualPaymentCentralDate = datePipe.transform(
          paymentBatchDetails.paymentScheduleBatch.actualPaymentCentralDate,
          'MM/dd/yyyy'
        );

        this.editPaymentBatchForm.patchValue({
          paymentBatchName:
            paymentBatchDetails.paymentScheduleBatch.paymentBatchName,
          paymentBatchScheduleDate: epaymentBatchScheduleDate,
          anticipatedPaymentDate: eanticipatedPaymentDate,
          actualPaymentCentralDate: eactualPaymentCentralDate,
          paymentCentralRequestID:
            paymentBatchDetails.paymentScheduleBatch.paymentCentralRequestID
        });

        this.paymentBatchEngagement = paymentBatchDetails.engagements.map(e => {
          return { ...e, editCheckBox: false };
        });

        this.onAddNewEngagements(true);
        this.selectedEngagements = this.paymentBatchEngagement.filter(
          e => e.associated === 1
        );
        this.engagementList = this.paymentBatchEngagement.filter(
          e => e.associated === 1
        );
        this.engagementList.forEach(item => {
          if (
            item.amount != item.actualizedAmount &&
            item.programTypeId === this.ProgramType.MSSP
          ) {
            this.isAmountreduced = true;
          }
        });
        this.copyAssociatedEngagements = this.paymentBatchEngagement.filter(
          e => e.associated === 1
        );
        this.paymentBatchEngagement.forEach(item => {
          if (item.associated === 1) {
            item.editCheckBox = true;
          }
        });
      });
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
    if (e.first + this.dataViewRecsPerPage > this.totalRecords) {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    }
    if (this.totalRecords > 0 && this.totalRecords > this.dataViewRecsPerPage) {
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
    if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      this.currentPageInfo =
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  reset() {
    if (this.isShowOnlyAssoctd) {
      if (this.dt) {
        this.dt.filter(1, 'associated', 'equals');
      }

      if (
        this.paymentBatchEngagement === null ||
        this.paymentBatchEngagement.length === 0
      ) {
        this.totalRecords = 0;
        this.currentPageInfo = 'No Records Found';
      } else {
        if (this.dt) {
          this.dt.sortField = 'engagementID';
          this.dt.sortOrder = -1;
          this.dt.reset();
          this.dt.filter(1, 'associated', 'equals');
        }

        this.totalRecords = this.engagementList.length;

        if (this.totalRecords > 0 && this.totalRecords > this.totalRecords) {
          this.currentPageInfo =
            'Showing 1 - ' +
            1 * this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
        if (this.totalRecords > 0 && this.totalRecords <= this.totalRecords) {
          this.currentPageInfo =
            'Showing 1 - ' +
            this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
      }
    } else {
      if (this.dt) {
        this.dt.sortField = 'engagementID';
        this.dt.sortOrder = -1;
        this.dt.reset();
      }

      if (
        this.paymentBatchEngagement === null ||
        this.paymentBatchEngagement.length === 0
      ) {
        this.totalRecords = 0;
        this.currentPageInfo = 'No Records Found';
      } else {
        this.totalRecords = this.paymentBatchEngagement.length;
        if (this.totalRecords > 0 && this.totalRecords > this.totalRecords) {
          this.currentPageInfo =
            'Showing 1 - ' +
            1 * this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
        if (this.totalRecords > 0 && this.totalRecords <= this.totalRecords) {
          this.currentPageInfo =
            'Showing 1 - ' +
            this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
      }
    }
  }

  selectRow(e, l) {
    const paymentBatchEngagement = this.paymentBatchEngagement.find(
      item => item.engagementID === l.engagementID
    );

    if (paymentBatchEngagement) {
      if (e === true) {
        paymentBatchEngagement.editCheckBox = true;
      } else {
        paymentBatchEngagement.editCheckBox = false;
      }
    }
  }

  getPaymentBatchStatus() {
    this.pmService.getPaymentBatchStatus().subscribe(engList => {
      this.paymentBatchStatus = engList;
    });
  }

  onSubmit(isExportToCSV = false) {
    this.loading = true;
    const datePipe = new DatePipe('en-US');

    this.updatePaymentBatch = {
      userid: this.settings.AliasName || '',
      requestDetailIdList: this.selectedEngagements.map(
        e => e.engagementID
      ) as number[],
      paymentBatchScheduleDate:
        datePipe.transform(
          this.editPaymentBatchForm.controls['paymentBatchScheduleDate'].value,
          'MM/dd/yyyy'
        ) || '',
      anticipatedPaymentDate:
        datePipe.transform(
          this.editPaymentBatchForm.controls['anticipatedPaymentDate'].value,
          'MM/dd/yyyy'
        ) || '',
      actualPaymentCentralDate:
        datePipe.transform(
          this.editPaymentBatchForm.controls['actualPaymentCentralDate'].value,
          'MM/dd/yyyy'
        ) || '',
      paymentBatchStatusId:
        this.editPaymentBatchForm.controls['paymentBatchStatus'].value
          .oDimEngagementPaymentBatchStatusId,
      paymentBatchName:
        this.editPaymentBatchForm.controls['paymentBatchName'].value,
      paymentCentralRequestID:
        this.editPaymentBatchForm.controls['paymentCentralRequestID'].value,
      udtPaymentSchedule: []
    };

    if (
      this.updatePaymentBatch.paymentBatchStatusId ===
      PaymentBatchStatus.Cancelled
    ) {
      this.selectedEngagements = [];
    }
    if (
      this.selectedEngagements.length !== 0 ||
      this.selectedEngagements.length !== undefined ||
      this.updatePaymentBatch.paymentBatchStatusId ===
        PaymentBatchStatus.Cancelled
    ) {
      for (const item of this.selectedEngagements) {
        if (
          !item.edited &&
          this.isEngagementInAssociated(item.engagementID || -1)
        )
          continue;

        this.updatePaymentBatch.udtPaymentSchedule?.push({
          requestDetailId: item.engagementID,
          engagementName: item.engagementName,
          engagementSubType: item.engagementSubType,
          partnerId: item.partnerID,
          payeeName: item.payeeName,
          contactName: item.contactName,
          contactEmail: item.contactEmail,
          emailLanguage: item.emailLanguage,
          accountCode: item.accountCode,
          internalOrderOrCostCenter: item.internalOrderOrCostCenter,
          currency: item.currency,
          amount: item.amount,
          netAmount: item.netAmount,
          actualizedAmount: item.actualizedAmount,
          taxAmount: item.taxAmount,
          msInvoiceNumber: item.msInvoiceNumber,
          msInvoiceDate: item.msInvoicePaidDate,
          paymentCentralTransactionID: item.paymentCentralTransactionID
        });
        const mn = this.paymentBatchEngagement.find(
          it => it.engagementID === item.engagementID
        );
        const msin = mn?.msInvoiceNumber;
        if (msin !== item.msInvoiceNumber) {
          this.collecteIdArray.push(mn?.engagementID);
        }
      }
    }
    if (
      this.selectedEngagements.length === 0 &&
      this.updatePaymentBatch.paymentBatchStatusId !==
        PaymentBatchStatus.Cancelled
    ) {
      this.loading = false;
      this.msgs = [];
      this.msgs.push({
        severity: 'error',
        detail: 'Please select any one Engagement from the list'
      });
      setTimeout(() => {
        this.msgs = [];
      }, 5000);
      return;
    }
    this.updatePaymentBatch.addids = this.selectedEngagements
      .filter(e => !this.isEngagementInAssociated(e.engagementID || -1))
      .map(e => e.engagementID)
      .toString();
    this.updatePaymentBatch.editids = this.selectedEngagements
      .filter(e => e.edited)
      .map(e => e.engagementID)
      .toString();
    this.updatePaymentBatch.deleteids = this.copyAssociatedEngagements
      .filter(
        e =>
          !this.selectedEngagements.some(
            e2 => e2.engagementID === e.engagementID
          )
      )
      .map(e => e.engagementID)
      .toString();

    if (this.programTypeId != null) {
      this.updatePaymentBatch.paymentBatchScheduleDate = this.formatDate(
        this.updatePaymentBatch.paymentBatchScheduleDate || ''
      );
      this.updatePaymentBatch.anticipatedPaymentDate = this.formatDate(
        this.updatePaymentBatch.anticipatedPaymentDate || ''
      );
      this.updatePaymentBatch.actualPaymentCentralDate =  this.updatePaymentBatch.actualPaymentCentralDate
      ? this.formatDate(
        this.updatePaymentBatch.actualPaymentCentralDate)
      : null;
    }

    this.pmService
      .updatePaymentBatch(this.updatePaymentBatch, this.programTypeId as any)
      .subscribe(
        messageResponse => {
          this.loading = false;
          this.apires = messageResponse;
          if (this.apires.success === true) {
            this.setMessage('Payment Batch Updated Successfully', 'success');
            this.editPaymentBatchForm.reset();
            this.showForm = false;
            if (isExportToCSV) {
              this.getPaymentBatchEng(
                this.updatePaymentBatch.paymentBatchName || ''
              ).then(() => {
                this.exportCSV();
                this.closeConfirmationModal();
                if (
                  this.updatePaymentBatch.paymentBatchStatusId ===
                  PaymentBatchStatus.InProgress
                ) {
                  this.pmService
                    .sendCsiCapLogicNotification(
                      this.paymentBatchEngagement
                        .filter(e => e.associated === 1)
                        .map(x => x.engagementID) as number[]
                    )
                    .toPromise()
                    .then(result => {
                      if (result == false)
                        this.setMessage(
                          'Failed to send payment notification email',
                          'warn'
                        );
                    });
                }
              });
              this.showForm = true;
            } else {
              this.selectedEngagements = [];
              this.pmService
                .ProcessPaymentCap()
                .toPromise()
                .then(() => {
                  if (
                    this.updatePaymentBatch.paymentBatchStatusId ===
                    PaymentBatchStatus.InProgress
                  ) {
                    this.pmService
                      .sendCsiCapLogicNotification(
                        this.paymentBatchEngagement
                          .filter(e => e.associated === 1)
                          .map(x => x.engagementID) as number[]
                      )
                      .toPromise()
                      .then(result => {
                        if (result == false)
                          this.setMessage(
                            'Failed to send payment notification email',
                            'warn'
                          );
                      });
                  }
                  this.showForm = false;
                })
                .finally(() => {
                  this.selectedEngagements = [];
                  if (
                    this.program !== null &&
                    this.program === ProgramTypesGUID.MSSP
                  ) {
                    const navigationExtras: NavigationExtras = {
                      state: {
                        selectedProgramOption: this.selectedProgramOption,
                        program: this.programTypeId
                      }
                    };
                    this.router.navigate(
                      ['events-payment-schedule'],
                      navigationExtras
                    );
                  } else {
                    this.router.navigate(['payment-schedule']);
                  }
                });
            }
          } else if (this.apires.success === false) {
            this.loading = false;
            if (
              this.apires.errorMessages &&
              this.apires.errorMessages.length > 0
            ) {
              this.setMessage(this.apires.errorMessages[0], 'error');
            }
            this.showForm = false;
          }
        },
        error => {
          this.loading = false;
          let errors: string[] = [];
          const paymentRequestIDWarningMessage =
            'Payment Central RequestID is already exists.';
          if (error.status === 400) {
            errors = this.commonService.getBadRequestErrors(error);
            for (const msg of errors) {
              this.msgs.push({ severity: 'warn', detail: msg });
            }
          } else if (error.error === paymentRequestIDWarningMessage) {
            this.setMessage(paymentRequestIDWarningMessage, 'warn');
          } else {
            this.setMessage(
              'Sorry an Error Occured while Creating Payment Batch',
              'warn'
            );
          }
          this.showForm = true;
        }
      );
  }

  onRowEditInit(eng: PaymentScheduleEngagements) {
    const engagementId = eng.engagementID as number;
    eng.editCheckBox = true;
    this.clonedEngs[engagementId] = { ...eng };
    if (this.editRowsCtr === 0) {
      this.editingHeaderCheck = true;
      this.firstEditInitEng = Object.create(eng);
    }
    this.editRowsCtr++;
    this.disableSubmit = true;
  }

  onRowEditSave(eng: PaymentScheduleEngagements) {
    if (eng.amount !== null) {
      const engagementId = eng.engagementID as number;
      delete this.clonedEngs[engagementId];
      eng.partnerID = this.firstEditInitEng.partnerID;
      eng.payeeName = this.firstEditInitEng.payeeName;
      eng.contactName = this.firstEditInitEng.contactName;
      eng.contactEmail = this.firstEditInitEng.contactEmail;
      eng.emailLanguage = this.firstEditInitEng.emailLanguage;
      eng.accountCode = this.firstEditInitEng.accountCode;
      eng.internalOrderOrCostCenter =
        this.firstEditInitEng.internalOrderOrCostCenter;
      eng.currency = this.firstEditInitEng.currency;
      eng.amount = this.firstEditInitEng.amount;
      eng.netAmount = this.firstEditInitEng.netAmount;
      eng.taxAmount = this.firstEditInitEng.taxAmount;
      eng.msInvoiceNumber = this.firstEditInitEng.msInvoiceNumber;
      eng.msInvoicePaidDate = this.firstEditInitEng.msInvoicePaidDate;
      eng.paymentCentralTransactionID =
        this.firstEditInitEng.paymentCentralTransactionID;
      eng.vendorID = this.firstEditInitEng.vendorID;
      eng.edited = true;
      this.editRowsCtr--;
    }
    if (this.editRowsCtr === 0) {
      this.editingHeaderCheck = false;
    }
    this.disableSubmit = false;
  }

  onRowEditCancel(eng: PaymentScheduleEngagements, index: number) {
    this.paymentBatchEngagement[index] =
      this.clonedEngs[eng.engagementID as number];
    delete this.clonedEngs[eng.engagementID as number];
    const idx = this.selectedEngagements.findIndex(
      e => e.engagementID === eng.engagementID
    );
    this.selectedEngagements.splice(idx, 1);
    this.onAddNewEngagements(this.isShowOnlyAssoctd);
    this.paymentBatchEngagement[index].editCheckBox = false;
    this.editing = false;
    this.editRowsCtr--;
    if (this.editRowsCtr === 0) {
      this.editingHeaderCheck = false;
    }
    this.disableSubmit = false;
  }

  cancelSearchNav() {
    if (this.program !== null && this.program === ProgramTypesGUID.MSSP) {
      const navigationExtras: NavigationExtras = {
        state: {
          selectedProgramOption: this.selectedProgramOption,
          program: this.programTypeId
        }
      };
      this.router.navigate(['events-payment-schedule'], navigationExtras);
    } else {
      this.router.navigate(['payment-schedule']);
    }
  }

  onAddNewEngagements(val) {
    this.isShowOnlyAssoctd = val;
    if (this.isShowOnlyAssoctd) {
      if (this.dt) {
        this.dt.filter(1, 'associated', 'equals');
      }
      this.totalRecords = this.paymentBatchEngagement.filter(
        e => e.associated === 1
      ).length;

      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      this.engagementList = this.paymentBatchEngagement;

      if (this.dt) {
        this.dt.reset();
      }
      this.totalRecords = this.paymentBatchEngagement.length;
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  get ProgramType() {
    return ProgramTypes;
  }

  formatDate(inputDate: string): string {
    if (inputDate == null || inputDate == '') return inputDate;
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  get disableInlineEdit(): boolean {
    return (
      this.programTypeId != null && this.programTypeId == ProgramTypesGUID.MSSP
    );
  }

  getSelectedProgramOptionByProgramTypeGuid(
    ProgramType: ProgramTypesGUID
  ): string {
    let selectedProgramOption = 'Events';
    switch (ProgramType) {
      case ProgramTypesGUID.MRPP:
        selectedProgramOption = 'MRPP';
        break;
      case ProgramTypesGUID.Events:
        selectedProgramOption = 'Events';
        break;
      case ProgramTypesGUID.MSSP:
        selectedProgramOption = 'CSI';
        break;
    }
    return selectedProgramOption;
  }
  
  convertToNumberValue(val: any): number {
    return Number(val);
  }
}
